<div class="col row" [formGroup]="form">
  <div class="col">
    @for (domain of domains; track domain) {
      <div>
        <div>{{ domain.domain }}</div>
        @if (domain.contracts.length == 0) {
          <div class="form-check text-muted">No contracts found</div>
        }
        @for (contract of domain.contracts; track contract) {
          <div class="form-check">
            <input
              class="form-check-input"
              id="input-contract"
              type="checkbox"
              [name]="contract.id"
              [formControlName]="contract.id" />
            <label class="form-check-label" [for]="contract.id"
              >{{ contract.name }} ({{ contract.type.name }})</label
            >
          </div>
        }
      </div>
    }
  </div>
  <div class="col-auto">
    <button
      *ngxPermissionsOnly="['contractCreate']"
      type="button"
      class="btn btn-sm btn-primary"
      (click)="showAddContract(domain)"
      (keydown.enter)="showAddContract(domain)">
      <i class="icon icon-plus">&nbsp;</i>New
    </button>
  </div>
</div>
